import gql from 'graphql-tag';

import cardTemplateDetails from '../../../cards/graphql/fragments/cardTemplateDetails';
import cardElementConfigurationDetails from '../../../cards/graphql/fragments/cardElementConfigurationDetails';

const getPrintSizeCard = gql`
  query getPrintSizeCard(
    $card_id: RecordID!
    $print_size_id: RecordID!
    $orientation: OrientationEnum = LANDSCAPE
  ) {
    card(id: $card_id) {
      id
      card_side_groups {
        total
        records {
          id
          side
          card_sides(
            slice: { limit: 999 }
            print_size_id: $print_size_id
            orientation: $orientation
          ) {
            total
            records {
              id
              name
              card_element_configurations {
                ...cardElementConfigurationDetails
              }
              card_template {
                ...cardTemplateDetails
              }
            }
          }
        }
      }
    }
  }
  ${cardElementConfigurationDetails}
  ${cardTemplateDetails}
`;

export default getPrintSizeCard;
